import { VisuallyHidden } from "@react-aria/visually-hidden";
import React from "react";
import { t } from "ttag";

import { HappyHourHeroBlock as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ANTONIO_URL, TYPEKIT_URL } from "../../utils/groups";
import { MenuViewer } from "../MenuViewer";

import hh from "../../styles/happy-hour.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const HappyHourHeroBlock = (props: Props) => {
    const value = props.value;
    if (!value.image) {
        return null;
    }
    const mobile = value.mobile_image ?? null;
    return (
        <section className={concatClassNames([hh.tokens, styles.hero])}>
            <link rel="stylesheet" href={TYPEKIT_URL} precedence="default" />
            <link rel="stylesheet" href={ANTONIO_URL} precedence="default" />
            {value.heading && (
                <VisuallyHidden elementType="h1">
                    {value.heading}
                </VisuallyHidden>
            )}
            <picture>
                {mobile && (
                    <source
                        media="(max-width: 768px)"
                        srcSet={mobile.url}
                        width={mobile.width}
                        height={mobile.height}
                    />
                )}
                <img
                    className={styles.photo}
                    src={value.image.url}
                    alt={value.image.default_alt_text}
                    width={value.image.width}
                    height={value.image.height}
                    loading="eager"
                    fetchPriority="high"
                />
            </picture>
            {value.menu_button_text && (
                <div className={styles.cta}>
                    <MenuViewer
                        title={value.menu_title || t`Beverage Menu`}
                        buttonText={value.menu_button_text}
                        buttonClassName={hh.ctaLarge}
                        pages={value.menu_pages ?? []}
                        document={value.menu_document ?? null}
                        textVersion={value.menu_text ?? null}
                        palette="happyHour"
                    />
                </div>
            )}
        </section>
    );
};
